import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PagseguroService  extends ServerService {
  private idSessao: string;

  constructor(http: HttpClient) {
    super(http);
  }

  crieSessao() {
    return new Promise( (resolve, reject) => {
      if( this.idSessao )
        return resolve(this.idSessao);

      this.facaPost('/pagseguro/nova-sessao', {}).then( (idSessao: any) => {
        this.idSessao = idSessao;
        resolve(idSessao);
      }).catch( (erro: Error) => {
        reject(erro);
      });
    });
  }

  crieSessaoFixa() {
    return new Promise( (resolve, reject) => {
      if( this.idSessao ) {
        return this.idSessao;
      }

      this.facaPost('/pagseguro/nova-sessao/fixa', {}).then( (idSessao: any) => {
        this.idSessao = idSessao;
        resolve(idSessao);
      }).catch( (erro: Error) => {
        reject(erro);
      });
    });
  }
}
